export const HTTP_STATUS_OK = 'Success'; // 200
export const HTTP_STATUS_TOKEN_EXPIRE = 'Token expired'; // 401
export const HTTP_STATUS_BAD_REQUEST = 'Bad request'; // 400
export const HTTP_STATUS_NOT_FOUND = 'Not found'; // 404
export const HTTP_STATUS_CONFLICT = 'Conflict error'; // 409
export const HTTP_STATUS_INTERNAL_SERVER = 'Internal server error'; // 500
export const ACCESS_TOKEN_KEY = 'BizB2B_Token_Key';
export const BASE_URL = 'https://eshopapi.comoffice.com';
export const BASE_PUNCHOUT_URL = 'https://eshopapi.comoffice.com:3083';
export const BASE_AUTH_URL = 'https://eshopauth.comoffice.com';
export const ReCAPTCHA_SECRET_KEY = '6Le4eDkkAAAAABjvpO1dkzs1tjfDT4lBCWhrR1I-';
export const ReCAPTCHA_SITE_KEY = '6Le4eDkkAAAAAGbci1odPtGEKuMhFDggEe48PMQV';
